import Promise from 'bluebird';
import _ from 'lodash';

import config from 'src/config';

function init() {
  if (!window.filepicker) {
    console.error('window.filepicker does not exist');
    return;
  }

  window.filepicker.setKey(config.FILE_PICKER_API_KEY);
}

function pick(options = {
  mimetype: 'image/*',
  services: ['COMPUTER', 'URL']
}) {
  if (!window.filepicker) return null;

  return new Promise((resolve, reject) => {
    window.filepicker.pick(options, resolve, reject, options.onProgress);
  });
}

/**
 * @param {DOMNode} - element
 * @param {Object} - [options]
 * @param {Function} - [options.onSuccess]
 * @param {Function} - [options.onError]
 * @param {Function} - [options.onProgress]
 */
function makeDropPane(element, options = {}) {
  if (!element) throw new Error('element');
  if (!window.filepicker) return;

  window.filepicker.makeDropPane(element, _.extend(options, {
    onSuccess: options.onSuccess,
    onError: options.onError,
    onProgress: options.onProgress
  }));
}

init();

export default {
  pick,
  makeDropPane
};



// WEBPACK FOOTER //
// ./src/lib/filepicker.js